var giftDeliveryModule = (function (_app, _estimateShippingPostcode, forms, _BaseView, _FieldView, _NewAddressForm) {
    
    var hiddenClass = 'hidden-block';

    var _forms = {
        current: 1,
        new: 2,
        list: 3
    };

    var _eventHandler = $({});
    var _changeEventName = 'changeActiveForm';
    var _activeForm = null;
    var _currentAddressID = null;

    var _Router = function () {

        
        var _setActiveForm = function (form) {
            _activeForm = form;
            _eventHandler.trigger(_changeEventName, form);
            _estimateShippingPostcode.hasAddress(_activeForm === _forms.current);
        }

        var _update = function(address) {
            if (app.models.page.get('BasketMode') === 1) {
                _currentAddressID = address.ID;
                _activeForm = (address.ID ? _forms.current : _forms.new);
                _setActiveForm(_activeForm);
                if (_activeForm === _forms.current) {
                    _estimateShippingPostcode.set(address.Postcode || null);
                }
            }
        }

        var _updateByChangeID = function (address) {
            if (_currentAddressID !== address.ID) {
                _update(address);
            }
        }

        app.models.delivery.giftCurrent.ready().done(_update);

        //app.models.delivery.giftCurrent.on('change:ID', _updateByChangeID);

        app.models.delivery.giftCurrent.onUpdate(_updateByChangeID);

        return {
            getActiveForm: function() {
                return _activeForm;
            },
            setActiveForm: _setActiveForm,
            onChangeActiveForm: function(fn) {
                if ($.isFunction(fn)) {
                    _eventHandler.on(_changeEventName, fn);
                }
            }
        };
    };

    var _router = _Router();

    var _calculateShipping = function (postcode) {
        if (app.models.page.get('BasketMode') !== 1) return;
        var _settings = CheckoutSettings.getBasketSettings();
        if (!_settings || _settings.ShippingByPostcodeEnabled !== true) {
            return;
        }

        var prevPostcode = _estimateShippingPostcode.get();

        if (prevPostcode === postcode) return;

        _estimateShippingPostcode.set(postcode);

        $('@estimateSubmint').trigger('inprogress', true);
        api.getPrices({ Postcode: postcode, PickupPoint: '' }).done(function(data) {
            if (data && data.Value) {
                _app.checkout._update(data);
            }
        }).always(function () {
            $('@estimateSubmint').trigger('inprogress', false);
        });
    };

    var GiftDeliveryView = _BaseView.extend({
        el: '@giftDelivery',

        events: {
            'click @btnChangeGiftAddress': '_changeAddress',
            'click @btnAddGiftAddressForm': 'showNewAddressForm'
        },

        initialize: function () {
            _.bindAll(this);

            if (this.settings('GiftEnabled')) {
                $('@GiftBasketCancelBtn').on('click', this._switchToGeneralMode);
                this.onChangeDeliverySectionMode(this._switchFormMode);
                this._switchFormMode();
            } else {
                this.$el.addClass(hiddenClass);
            }

        },

        _switchFormMode: function (e, mode) {
            mode = mode || this.getDeliverySectionMode();
            this.$el.toggleClass(hiddenClass, mode !== this.deliverySectionMode.gift);
            $('@GiftBasketCancelBtn').toggleClass(hiddenClass, mode !== this.deliverySectionMode.gift);
        },

        _switchToGeneralMode: function () {
            $('@GiftBasketCancelBtn').addClass('checkout-button-delivery-address-mode__processing');
            app.checkout.switchBasketMode(this.deliverySectionMode.general)
                .always(_.bind(function () {
                    $('@GiftBasketCancelBtn').removeClass('checkout-button-delivery-address-mode__processing');
                }, this));
        },

        _changeAddress: function (e) {
            e.preventDefault();
            this.showListAddressForm();
        },

        _showCurrentGiftAddress: function (e) {
            e.preventDefault();
            this.showNewAddressForm();
        },

        showNewAddressForm: function (e) {
            e && e.preventDefault();
            _router.setActiveForm(_forms.new);
        },

        showListAddressForm: function (e) {
            e && e.preventDefault();
            _router.setActiveForm(_forms.list);
        }
    });

    var NewGiftAddressView = Backbone.View.extend({
        el: '@newGiftDelivery',

        events: {
            'click @btnAddGiftAddress': 'addAddress',
            'click @btnUseAnotherGiftAddress': '_showCurrentGiftAddress',
            'click @btnChangeTypeOfDelivery': '_back'
        },

        initialize: function () {
            _.bindAll(this);
            this.$fields = this.$('@giftFields');
            this.$btnAddAddress = this.$('@btnAddGiftAddress');
            this.$btnUseAnotherAddress = this.$('@btnUseAnotherGiftAddress');
            
            this.occasionView = GiftOccasionView('@newGiftDeliveryOccasions', true, false);

            _router.onChangeActiveForm(_.bind(this._toggle, this));
            this._toggle(null, _router.getActiveForm());

            if (!IsAuthorized()) {
                this.$btnAddAddress.remove();
            } else {
                this.collection.on('inProgress', this._inProgress);
            }

            var _this = this;
            this.collection.each(function(model) {
                var name = model.get('Name');
                if (name.match(/^(gift_Postcode)$/i)) {
                    _this._postcodeModel = model;
                    model.on('valueChanged',  function(field) {
                        if (field.isValid === true) {
                            _calculateShipping(field.value);
                        }
                    });
                }
            });

            this._render();
        },

        _render: function () {
            this.form = _NewAddressForm(this.collection, _FieldView, this.$fields);
            this.form.render();
        },

        _toggle: function (e, form) {
            var isActive = form === _forms.new;

            this.collection.setActive(isActive);

            this.$btnUseAnotherAddress.toggleClass(hiddenClass, !app.models.delivery.giftCurrent.get('ID'));

            this.$el.toggle(isActive);

            //this.occasionView.$el.toggleClass('hidden-block', !!_currentAddressID);

            if (isActive && this._postcodeModel) {
                var value = this._postcodeModel.get('Value');
                var prevPostcode = _estimateShippingPostcode.get();
                if (value && this._postcodeModel.isValid() && value !== prevPostcode) {
                    _calculateShipping(value);
                }
            }
        },

        _showCurrentGiftAddress: function() {
            _router.setActiveForm(_forms.current);
        },

        addAddress: function (e) {
            e.preventDefault();
            /**
             * / Replace to useThisGiftAddress
             */
            //_app && _app.event && _app.event.useThisAddress();

            //var _tryToSaveOccasions = !_currentAddressID;

            this.collection.save(_.bind(function() {
                //if (_tryToSaveOccasions) {
                    this.occasionView.save();
                //}
            }, this));
        },

        _back: function (e) {
            e.preventDefault();
        },

        _inProgress: function (state) {
            this.$btnAddAddress.toggleClass('checkout-button-add-address', !state);
            this.$btnAddAddress.toggleClass('checkout-button-add-address__processing', state);
        }
    });

    var CurrentGiftAddressView = Backbone.View.extend({
        el: '@lastGiftAddressContainer',
        initialize: function () {
            _.bindAll(this);
            this.$lastAddress = this.$('@lastGiftAddress');

            _router.onChangeActiveForm(_.bind(this._toggle, this));
            this._toggle(null, _router.getActiveForm());
            this.render();
            this.model.on('change', this.render);
        },

        render: function () {
            var address = this.model.toJSON();

            if (address.AdditionalData) {
                var additionalData = JSON.parse(address.AdditionalData);
                address.GiftMessage = additionalData.GiftMessage;
            }

            this.$lastAddress.html($.tmpl('bt-checkout-delivery-address', address));
        },
        _toggle: function (e, form) {
            var isActive = form === _forms.current;
            this.model.setActive(isActive);
            this.$el.toggle(isActive);

            //if (isActive) {
            //    var postcode = this.model.get('Postcode');
            //    if (postcode) {
            //        _calculateShipping(postcode);
            //    }
            //}
        }
    });

    var GiftAddressesListView = Backbone.View.extend({
        el: '@giftAddressListContainer',
        initialize: function () {
            _.bindAll(this, '_render', '_inProgress');
            this.$addressList = this.$('@giftAddressList');

            _router.onChangeActiveForm(_.bind(this._toggle, this));
            //this._toggle(null, _router.getActiveForm());
            //this.render();
            //this.model.on('change', this.render);
        },

        _render: function (data) {
            var list = data && data.Value && data.Value.AddressesList || [];
            if (list.length > 1) {
                this.$addressList.empty();
                _.each(list, _.bind(function (address) {

                    if (address.AdditionalData) {
                        var additionalData = JSON.parse(address.AdditionalData);
                        address.GiftMessage = additionalData.GiftMessage;
                    }

                    var el = $.tmpl('bt-checkout-delivery-gift-address', address);
                    this.$addressList.append(el);
                    el.on('click', _.bind(this._select, this, address.ID, el));
                }, this));

                this.$el.toggle(true);
            } else {
                _router.setActiveForm(_forms.new);
            }
            //this.$lastAddress.html($.tmpl('bt-checkout-delivery-address', this.model.toJSON()));
        },
        _select: function (id, el, e) {
            if (e) e.preventDefault();
            this._inProgress(el, true);
            app.checkout.applyGiftDeliveryAddress(id).done(_.bind(function() {
                this._inProgress(el, false);
            }, this));
        },
        _toggle: function (e, form) {
            if (form === _forms.list) {
                api.getUserGiftAddresses().done(this._render);
            } else {
                this.$el.toggle(false);
            }
        },
        _inProgress: function ($el, isActive) {
            $el.toggleClass('processing-animation', !!isActive);
        }
    });

    new NewGiftAddressView({ collection: app.models.delivery.giftDecoration });
    new CurrentGiftAddressView({ model: app.models.delivery.giftCurrent });
    new GiftAddressesListView();

    new GiftDeliveryView();

    GiftOccasionView('@giftDeliveryOccasions', false, _router);
});